// /**
//  * Post Order - Add
//  */

// React
import React, {useState, useContext, useEffect} from 'react';
// Context
import AuthContext from '../../authContext';

// react hook form
import {useForm} from 'react-hook-form';

// UI
import theme from '../../theme';
import {makeStyles, Theme, createStyles} from '@material-ui/core/styles';
import {
  TextField,
  Grid,
  Button,
  Paper,
  Typography,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  DialogContent,
  IconButton,
  DialogActions,
  Dialog,
  CircularProgress,
  Divider,
  Checkbox,
} from '@material-ui/core';
import Modal from '../../components/Modal';
import {MuiPickersUtilsProvider, DatePicker} from '@material-ui/pickers';
import jMoment from 'moment-jalaali';
import JalaliUtils from '@date-io/jalaali';

// Icon
import Icon from '@mdi/react';
import {
  mdiPhoneOutline,
  mdiMapMarkerOutline,
  mdiPackageVariantClosed,
  mdiCalendar,
  mdiArrowRight,
  mdiAccountOutline,
  mdiClose,
  mdiArchiveOutline,
  mdiCheck,
  mdiCityVariant,
  mdiCity,
  mdiBank,
  mdiCubeSend,
  mdiMessageProcessingOutline,
  mdiPackageVariant,
  mdiPostOutline,
  mdiWeightKilogram,
  mdiSendCircleOutline,
} from '@mdi/js';

import Detail from './index';

// Type
import {SelectorProps, Props} from './interfaces';

// helpers'
import {
  convertPersianDigit2English,
  translateSendDeliveryType,
} from '../../utils/helpers';
import {connect} from 'react-redux';
import {compose} from 'redux';
import {createStructuredSelector} from 'reselect';
import {Store} from '../../redux/reducers';
import {
  makeSelectCurrentPostOrder,
  makeSelectError,
  makeSelectLoading,
} from '../orders/selectors';

import {Link, useHistory} from 'react-router-dom';
import {
  makeSelectOrder,
  makeSelectPostOrder,
  makeSelectCities,
  makeSelectCitiesLoading,
  makeSelectProvincesLoading,
  makeSelectProvinces,
} from '../orders/selectors';
import {
  getPostOrderWithIdAction,
  createPostOrderAction,
  getProvincesAction,
  getCitiesAction,
  getPostOrdersAction,
} from '../orders/actions';
import {Payload} from '../orders/interfaces';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Can from '../../components/Can';

jMoment.loadPersian({dialect: 'persian-modern', usePersianDigits: true});

type Inputs = {
  insuranceType: string;
  parcelType: string;
  serviceType: string;
  smsService: string;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    paper: {
      marginTop: '36px',
      marginBottom: '36px',
      marginLeft: '20px',
      marginRight: '20px',
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      border: '1px solid #ddd',
      borderRadius: '4px',
      '@media (max-width: 768px)': {
        padding: theme.spacing(0),
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(3),
        backgroundColor: theme.palette.background.default,
      },
    },
    // Cancel Dialog
    cancelIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),

      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.success.main,
      },
    },
    cancelTitle: {
      fontSize: '16px',
      fontWeight: 500,
      textAlign: 'center',
      lineHeight: 2,
      marginBottom: theme.spacing(3),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    rtlIcon: {
      marginRight: theme.spacing(1),
      transform: 'scale(-1, 1)',
    },
    headerBox: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '18px',
    },
    margin: {
      // margin: theme.spacing(1),
    },
    withoutLabel: {
      marginTop: theme.spacing(3),
    },
    textInput: {
      // width: '25ch',
      '& input, .MuiSelect-root': {
        padding: '6px 0 12px !important',
      },

      '& .MuiInput-underline::before': {
        borderBottom: '1px solid #d8d8d8 !important',
      },
    },

    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontWeight: 500,
      width: '100%',
      '& > *': {
        // margin: theme.spacing(0, 0, 0, 1),
      },
    },
    divider: {
      width: '98%',
      margin: '0 auto',
      height: 0,
    },
    icon: {
      color: '#8a8a8a',
      marginRight: theme.spacing(1),
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 400,
      color: '#8a8a8a',
      marginRight: '8px',
      marginTop: '21px',
    },
    addIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      // marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.green.main,
      },
    },
    link: {
      textDecoration: 'none !important',
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  })
);

function useOnMount(handler: any) {
  return React.useEffect(handler, []);
}

function required(displayName: any) {
  return function validateRequired(value: any) {
    return value !== null || `${displayName} is required.`;
  };
}

function Add(props: Props) {
  const classes = useStyles();
  const authContext = useContext(AuthContext);
  const history = useHistory();
  const {register, handleSubmit, errors, watch, setValue, getValues} =
    useForm<Inputs>({
      defaultValues: {
        smsService: '',
        insuranceType: '',
        parcelType: '',
        deliveryServiceType: 1,
      },
    });
  const [items, setItems] = useState<any>([]);
  const [itemDeleted, setItemDeleted] = useState<any>({});
  const [insuranceType, setInsuranceType] = useState<any>('');
  const [parcelType, setParcelType] = useState<any>('2');
  const [serviceType, setServiceType] = useState<any>(1);
  const [postProvince, setPostProvince] = useState<any>('');
  const [postCity, setPostCity] = useState<any>('');
  const [weight, setWeight] = useState<any>('');
  const [itemsInfo, setItemsInfo] = useState<any>([]);
  const [openAddItem, setOpenAddItem] = useState(false);
  const [finishedFirstStep, setFinishedFirstStep] = useState(false);
  const [smsService, setSmsService] = useState<any>('');
  const [openAddInventoryItem, setOpenAddInventoryItem] = useState(false);
  const [openConfirmDelete, setOpenConfirmDelete] = useState(false);
  const [openAutocomplete, setOpenAutocomplete] = React.useState(false);
  const [openCityAutocomplete, setOpenCityAutocomplete] = React.useState(false);
  const [valueWarehouse, setValueWarehouse] = React.useState<any | null>(null);
  const [checkSubmit, setCheckSubmit] = React.useState(false as boolean);
  const [nonStandard, setNonStandard] = React.useState(false as boolean);

  const onSubmit = () => {
    handleCreatePostOrder();
  };

  const handleCloseCheckConfirm = () => {
    setCheckSubmit(false);
  };

  const handleClose = () => {
    setOpenConfirmDelete(false);
  };

  const deleteItemsToParcels = () => {
    const newValue = items.filter((item: any) => item.id !== itemDeleted.id);
    const newValueInfo = itemsInfo.filter(
      (item: any) => item.id !== itemDeleted.id
    );

    setItems(newValue);
    setItemsInfo(newValueInfo);
    setOpenAddItem(false);
    handleClose();
  };

  const checkAllItemFilled = (): boolean => {
    const items = [serviceType, smsService, insuranceType, parcelType, weight];
    return items.some(item => item === '');
  };

  const handleCreatePostOrder = () => {
    const {id} = props.match.params;
    props.createPostOrderDispatch({
      id,
      body: {
        orderId: props.currentPostOrder?.orderId,
        id,
        serviceType,
        insuranceType,
        parcelType,
        smsService: smsService.replace(/'/g, ''),
        cityId: postCity.id,
        isnonstandard: nonStandard,
        weight,
      },
      callback: () => {
        // setOpenAddItem(true);
        setFinishedFirstStep(true);
      },
    });
  };

  const getBarcode = () => {
    const {id} = props.currentPostOrder;
    props.createPostOrderDispatch({
      id,
      body: {
        send: true,
      },
    });
  };

  const getOrder = () => {
    const {id} = props.match.params;
    props.orderWithIdActionDispatch(id);
  };

  const getCities = (provinceId: number) => {
    props.citiesActionDispatch({
      provinceId: {equals: provinceId},
      postCode: {notEquals: 0},
    });
  };

  const getProvinces = () => {
    props.provincesActionDispatch({});
  };

  useEffect(() => {
    if (props.currentPostOrder.id) {
      getProvinces();
    }
  }, [props.currentPostOrder]);

  useEffect(() => {
    if (props.cities.length && props.currentPostOrder?.id) {
      const city = props.cities.filter(
        (city: any) => city.name === props.currentPostOrder.customerCity
      );
      setPostCity(city[0]);
    }
  }, [props.cities, props.currentPostOrder]);

  useEffect(() => {
    if (props.provinces.length && props.currentPostOrder?.id) {
      const province = props.provinces.filter(
        (province: any) =>
          province.name === props.currentPostOrder.customerProvince
      );
      setPostProvince(province[0]);
    }
  }, [props.provinces, props.currentPostOrder]);

  useEffect(() => {
    if (postProvince) {
      getCities(postProvince.id);
    } else {
      setPostCity({});
    }
  }, [postProvince]);

  React.useEffect(() => {
    getOrder();
    setSmsService('false');
    setInsuranceType(1);
  }, []);

  useEffect(() => {
    if (props.currentPostOrder?.deliveryType) {
      if (props.currentPostOrder.deliveryType === 'EXPRESS_POST') {
        setServiceType(1);
      }
      if (props.currentPostOrder.deliveryType === 'SPECIAL_POST') {
        setServiceType(2);
      }
    }
  }, [props.currentPostOrder]);

  useEffect(() => {
    switch (true) {
      case serviceType === 1:
        setParcelType(2);
        break;
      case serviceType === 2 && Number(weight) <= 2000:
        setParcelType(4);
        break;
      case serviceType === 2 && Number(weight) > 2000:
        setParcelType(10);
        break;
      case serviceType !== 1 && serviceType !== 2:
        setParcelType('');
        break;
    }
  }, [serviceType, weight]);

  const handleChange = (name: any, setAmount: any, value: any) => {
    setValue(`${name}`, value);
    setAmount(value);
  };

  const handleDeliveryDateChange = (date: any) => {
    setValue(
      'deliveryDate',
      convertPersianDigit2English(date.format('YYYY-MM-DD'))
    );
  };

  const values = getValues();

  return (
    <>
      <div className={classes.headerBox}>
        <Typography variant="h6" component="h2">
          {`
        ارسال سفارش
        `}{' '}
          {props.match.params.id} - {'پستی'}
        </Typography>
      </div>

      <Grid
        container
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <Button
          aria-label="details"
          size="medium"
          onClick={() => window.history.back()}
        >
          <Icon path={mdiArrowRight} size={1} className={classes.icon} />
          {'بازگشت'}
        </Button>
      </Grid>
      <form style={{display: 'flex'}} onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={5} alignItems="flex-start">
          <Paper
            elevation={3}
            className={classes.paper}
            variant="elevation"
            square
          >
            <div style={{marginTop: '-66px'}} className={classes.addIcon}>
              <Icon
                path={mdiPackageVariantClosed}
                size={4}
                color={theme.palette.green.main}
              />
            </div>
            <Grid
              style={{padding: '20px'}}
              container
              spacing={5}
              alignItems="flex-start"
            >
              <Grid container item xs={6} sm={3} alignItems="flex-end">
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiAccountOutline}
                      size={1}
                      className={classes.icon}
                    />
                  </span>
                  <Grid item xs={11}>
                    <TextField
                      label="نام سفارش دهنده"
                      className={classes.textInput}
                      value={props.currentPostOrder.customerName}
                      id="admin"
                      InputProps={{
                        readOnly: true,
                      }}
                      InputLabelProps={{
                        shrink: !!props.currentPostOrder.customerName,
                      }}
                    />
                  </Grid>
                </div>
              </Grid>
              <Grid container item xs={12} sm={3} alignItems="flex-end">
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiPhoneOutline}
                      size={1}
                      className={classes.icon}
                    />
                  </span>

                  <div style={{width: '100%'}}>
                    <TextField
                      fullWidth
                      id="agentName"
                      label="شماره موبایل"
                      className={classes.textInput}
                      value={props.currentPostOrder.customerPhoneNumber}
                      error={errors.agentName && true}
                      InputProps={{
                        readOnly: true,
                      }}
                      InputLabelProps={{
                        shrink: !!props.currentPostOrder.customerPhoneNumber,
                      }}
                    />
                  </div>
                </div>
              </Grid>
              <Grid container item xs={6} sm={3} alignItems="flex-end">
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiCityVariant}
                      size={1}
                      className={classes.icon}
                    />
                  </span>

                  <span style={{width: '100%'}}>
                    <TextField
                      fullWidth
                      id="agentPhoneNumber"
                      label="استان"
                      className={classes.textInput}
                      value={props.currentPostOrder.customerProvince}
                      InputProps={{
                        readOnly: true,
                      }}
                      InputLabelProps={{
                        shrink: !!props.currentPostOrder.customerProvince,
                      }}
                    />
                  </span>
                </div>
              </Grid>
              <Grid container item xs={6} sm={3} alignItems="flex-end">
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon path={mdiCity} size={1} className={classes.icon} />
                  </span>

                  <span style={{width: '100%'}}>
                    <TextField
                      fullWidth
                      id="agentPhoneNumber"
                      label="شهر"
                      className={classes.textInput}
                      value={props.currentPostOrder.customerCity}
                      InputProps={{
                        readOnly: true,
                      }}
                      InputLabelProps={{
                        shrink: !!props.currentPostOrder.customerCity,
                      }}
                    />
                  </span>
                </div>
              </Grid>
              <Grid container item xs={12} sm={3} alignItems="flex-end">
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiCalendar}
                      size={1}
                      className={classes.icon}
                    />
                  </span>

                  <span style={{width: '100%'}}>
                    <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                      <DatePicker
                        id="deliveryDate"
                        label="تاریخ تحویل محموله"
                        format="jYYYY/jMM/jDD"
                        disablePast
                        disableToolbar
                        fullWidth
                        okLabel="تأیید"
                        cancelLabel="لغو"
                        defaultValue={null}
                        className={classes.textInput}
                        value={props.currentPostOrder.orderDeliveryDate}
                        onChange={handleDeliveryDateChange}
                        readOnly
                        error={errors.hasOwnProperty('deliveryDate')}
                        helperText={
                          errors.deliveryDate && errors.deliveryDate.message
                        }
                      />
                    </MuiPickersUtilsProvider>
                  </span>
                </div>
              </Grid>
              <Grid container item xs={12} sm={3} alignItems="flex-end">
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiPostOutline}
                      size={1}
                      className={classes.icon}
                    />
                  </span>

                  <span style={{width: '100%'}}>
                    <TextField
                      fullWidth
                      id="agentPhoneNumber"
                      label="کد پستی"
                      className={classes.textInput}
                      value={props.currentPostOrder.customerZipCode}
                      InputProps={{
                        readOnly: true,
                      }}
                      InputLabelProps={{
                        shrink: !!props.currentPostOrder.customerZipCode,
                      }}
                    />
                  </span>
                </div>
              </Grid>
              <Grid item xs={12} sm={3}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiSendCircleOutline}
                      size={1}
                      className={classes.rtlIcon}
                    />
                  </span>
                  <span style={{width: '100%'}}>
                    <TextField
                      fullWidth
                      id="agentPhoneNumber"
                      label="نوع ارسال"
                      className={classes.textInput}
                      value={translateSendDeliveryType(
                        props.currentPostOrder.deliveryType
                      )}
                      InputProps={{
                        readOnly: true,
                      }}
                      InputLabelProps={{
                        shrink: !!props.currentPostOrder.deliveryType,
                      }}
                    />
                  </span>
                </div>
              </Grid>
              <Grid container item xs={12} alignItems="flex-end">
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiMapMarkerOutline}
                      size={1}
                      className={classes.icon}
                    />
                  </span>

                  <div style={{width: '100%'}}>
                    <TextField
                      fullWidth
                      label="آدرس مقصد"
                      variant="filled"
                      value={props.currentPostOrder.customerAddress}
                      InputProps={{
                        readOnly: true,
                      }}
                      InputLabelProps={{
                        shrink: !!props.currentPostOrder.customerAddress,
                      }}
                    />
                  </div>
                </div>
              </Grid>
              <Grid container item xs={6} sm={3} alignItems="flex-end">
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiWeightKilogram}
                      size={1}
                      className={classes.icon}
                    />
                  </span>

                  <span style={{width: '100%'}}>
                    <TextField
                      fullWidth
                      id="agentPhoneNumber"
                      label="وزن دقیق"
                      className={classes.textInput}
                      value={weight}
                      onChange={e => setWeight(e.target.value)}
                    />
                  </span>
                </div>
              </Grid>{' '}
              <Grid container item xs={6} sm={3} alignItems="flex-end">
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiCityVariant}
                      size={1}
                      className={classes.icon}
                    />
                  </span>

                  <span style={{width: '100%'}}>
                    <FormControl style={{width: '100%'}}>
                      <Autocomplete
                        open={openAutocomplete}
                        onOpen={() => {
                          setOpenAutocomplete(true);
                        }}
                        onClose={() => {
                          setOpenAutocomplete(false);
                        }}
                        getOptionSelected={(option, value) =>
                          option.name === value?.name
                        }
                        getOptionLabel={option => option.name}
                        options={props.provinces}
                        value={postProvince}
                        loading={props.provincesLoading}
                        onChange={(event: any, newValue: any) => {
                          handleChange(
                            'postProvince',
                            setPostProvince,
                            newValue
                          );
                        }}
                        renderInput={params => (
                          <TextField
                            {...params}
                            label="استان پست"
                            inputRef={register({required: false})}
                            name="postProvince"
                            id="postProvince"
                            InputProps={{
                              ...params.InputProps,
                              endAdornment: (
                                <React.Fragment>
                                  {props.provincesLoading ? (
                                    <CircularProgress
                                      color="inherit"
                                      size={20}
                                    />
                                  ) : null}
                                  {params.InputProps.endAdornment}
                                </React.Fragment>
                              ),
                            }}
                          />
                        )}
                      />
                    </FormControl>
                  </span>
                </div>
              </Grid>
              <Grid container item xs={6} sm={3} alignItems="flex-end">
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon path={mdiCity} size={1} className={classes.icon} />
                  </span>

                  <span style={{width: '100%'}}>
                    <FormControl style={{width: '100%'}}>
                      <Autocomplete
                        open={openCityAutocomplete}
                        onOpen={() => {
                          setOpenCityAutocomplete(true);
                        }}
                        onClose={() => {
                          setOpenCityAutocomplete(false);
                        }}
                        getOptionSelected={(option, value) =>
                          option.name === value?.name
                        }
                        getOptionLabel={option => option.name}
                        options={props.cities}
                        value={postCity}
                        loading={props.citiesLoading}
                        onChange={(event: any, newValue: any) => {
                          handleChange('postCity', setPostCity, newValue);
                        }}
                        renderInput={params => (
                          <TextField
                            {...params}
                            label="شهر پست"
                            inputRef={register({required: false})}
                            name="postCity"
                            id="postCity"
                            InputProps={{
                              ...params.InputProps,
                              endAdornment: (
                                <React.Fragment>
                                  {props.citiesLoading ? (
                                    <CircularProgress
                                      color="inherit"
                                      size={20}
                                    />
                                  ) : null}
                                  {params.InputProps.endAdornment}
                                </React.Fragment>
                              ),
                            }}
                          />
                        )}
                      />
                    </FormControl>
                  </span>
                </div>
              </Grid>
              <Divider className={classes.divider} />
              <Grid container item xs={6} sm={3} alignItems="flex-end">
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiCubeSend}
                      size={1}
                      className={classes.icon}
                    />
                  </span>
                  <span style={{width: '100%'}}>
                    <FormControl style={{width: '100%'}}>
                      <InputLabel id="serviceTypeLabel">نوع ارسال</InputLabel>
                      <Select
                        fullWidth
                        id="serviceType"
                        name="deliveryServiceType"
                        inputProps={{
                          name: 'serviceType',
                          id: 'serviceType',
                        }}
                        labelId="serviceTypeLabel"
                        value={serviceType}
                        defaultValue={1}
                        onChange={e => {
                          handleChange(
                            'serviceType',
                            setServiceType,
                            e.target.value
                          );
                        }}
                        className={classes.textInput}
                        inputRef={register({required: true})}
                      >
                        <MenuItem value={1}>پیشتاز</MenuItem>
                        <MenuItem value={2}>سفارشی</MenuItem>
                        {/*<MenuItem value={3}>ویژه</MenuItem>*/}
                      </Select>
                    </FormControl>
                  </span>
                </div>
              </Grid>{' '}
              <Grid container item xs={6} sm={3} alignItems="flex-end">
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiPackageVariant}
                      size={1}
                      className={classes.icon}
                    />
                  </span>

                  <span style={{width: '100%'}}>
                    <FormControl style={{width: '100%'}}>
                      <InputLabel id="parcelTypeLabel">نوع بسته</InputLabel>
                      <Select
                        fullWidth
                        id="parcelType"
                        name="parcelType"
                        inputProps={{
                          name: 'parcelType',
                          id: 'parcelType',
                        }}
                        labelId="parcelTypeLabel"
                        disabled={!serviceType}
                        // value={parcelType}
                        defaultValue={2}
                        onChange={e =>
                          handleChange(
                            'parcelType',
                            setParcelType,
                            e.target.value
                          )
                        }
                        className={classes.textInput}
                        inputRef={register({required: true})}
                      >
                        <MenuItem
                          disabled={serviceType === 1 || serviceType === 2}
                          value={1}
                        >
                          پاکت پیشتاز
                        </MenuItem>
                        <MenuItem disabled={serviceType === 2} value={2}>
                          بسته پیشتاز
                        </MenuItem>
                        <MenuItem
                          disabled={serviceType === 1 || serviceType === 2}
                          value={3}
                        >
                          پاکت سفارشی
                        </MenuItem>
                        <MenuItem disabled={serviceType !== 2} value={4}>
                          بسته سفارشی
                        </MenuItem>
                        <MenuItem
                          disabled={serviceType === 1 || serviceType === 2}
                          value={5}
                        >
                          مطبوع
                        </MenuItem>
                        <MenuItem
                          disabled={serviceType === 1 || serviceType === 2}
                          value={6}
                        >
                          کیسه M
                        </MenuItem>
                        <MenuItem disabled={serviceType !== 2} value={10}>
                          امانت
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </span>
                </div>
              </Grid>{' '}
              <Grid container item xs={6} sm={3} alignItems="flex-end">
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon path={mdiBank} size={1} className={classes.icon} />
                  </span>

                  <span style={{width: '100%'}}>
                    <FormControl style={{width: '100%'}}>
                      <InputLabel id="insuranceTypeLabel">نوع بیمه</InputLabel>
                      <Select
                        fullWidth
                        id="insuranceType"
                        name="insuranceType"
                        inputProps={{
                          name: 'insuranceType',
                          id: 'insuranceType',
                        }}
                        labelId="insuranceTypeLabel"
                        value={insuranceType}
                        onChange={e =>
                          handleChange(
                            'insuranceType',
                            setInsuranceType,
                            e.target.value
                          )
                        }
                        className={classes.textInput}
                        inputRef={register({required: true})}
                      >
                        <MenuItem value={1}>بیمه عادی</MenuItem>
                        <MenuItem value={2}>وجه نقد</MenuItem>
                        <MenuItem value={3}>اوراق و اسناد بانکی</MenuItem>
                        <MenuItem value={4}>بار انبوه</MenuItem>
                        <MenuItem value={5}>سایر</MenuItem>
                      </Select>
                    </FormControl>
                  </span>
                </div>
              </Grid>{' '}
              <Grid container item xs={6} sm={3} alignItems="flex-end">
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiMessageProcessingOutline}
                      size={1}
                      className={classes.icon}
                    />
                  </span>

                  <span style={{width: '100%'}}>
                    <FormControl style={{width: '100%'}}>
                      <InputLabel id="smsServiceLabel">سرویس پیامک</InputLabel>
                      <Select
                        fullWidth
                        id="smsService"
                        name="smsService"
                        inputProps={{
                          name: 'smsService',
                          id: 'smsService',
                        }}
                        labelId="smsServiceLabel"
                        value={smsService}
                        onChange={e =>
                          handleChange(
                            'smsService',
                            setSmsService,
                            e.target.value
                          )
                        }
                        className={classes.textInput}
                        inputRef={register({required: true})}
                      >
                        <MenuItem value={'true'}>بلی</MenuItem>
                        <MenuItem value={'false'}>خیر</MenuItem>
                      </Select>
                    </FormControl>
                  </span>
                </div>
              </Grid>{' '}
              <Grid container item xs={6} sm={3} alignItems="flex-end">
                <div className={classes.item}>
                  <span style={{width: '100%'}}>
                    {'مرسوله غیر استاندارد'}
                    <Checkbox
                      size="medium"
                      onChange={() => {
                        setNonStandard(!nonStandard);
                      }}
                      checked={nonStandard}
                    />
                  </span>
                </div>
              </Grid>{' '}
            </Grid>
          </Paper>
          <Grid
            item
            container
            style={{paddingTop: 0, paddingBottom: 0}}
            justify="flex-end"
            xs={12}
          >
            <Grid item>
              <Button
                type="submit"
                size="large"
                data-cy="search"
                autoFocus
                variant="contained"
                color="secondary"
                disabled={checkAllItemFilled()}
              >
                {'تایید سفارش پستی'}
              </Button>
            </Grid>
          </Grid>
          {finishedFirstStep && (
            <Grid item container justify="flex-end" xs={12}>
              <Grid container item justify="flex-end" spacing={2} xs={12}>
                <Grid item>
                  <Can
                    role={authContext.user.role}
                    perform="/post-orders-queue"
                    yes={() => (
                      <Link className={classes.link} to="/post-orders-queue">
                        <Button
                          type="submit"
                          fullWidth
                          variant="contained"
                          color="secondary"
                          size="large"
                          data-cy="search"
                          // disabled={props.loading}
                        >
                          {`تایید و ارسال به صف`}
                        </Button>
                      </Link>
                    )}
                  />
                </Grid>
                <Grid item>
                  <Button
                    type="button"
                    fullWidth
                    variant="contained"
                    className={classes.link}
                    color="secondary"
                    size="large"
                    data-cy="search"
                    disabled={props.loading || !!props.postOrder?.barcode}
                    onClick={() => getBarcode()}
                  >
                    {`تایید و دریافت بارکد`}{' '}
                    {props.loading && <CircularProgress size={24} />}
                  </Button>
                </Grid>
                {props.postOrder?.barcode && (
                  <Grid item>
                    <Button
                      type="button"
                      fullWidth
                      variant="contained"
                      className={classes.link}
                      color="secondary"
                      size="large"
                      data-cy="search"
                      disabled={!props.postOrder?.barcode || props.loading}
                      onClick={() => {
                        const win = window.open(
                          `/post-print-labels/${props.currentPostOrder.id}`,
                          '_blank'
                        )!;
                        win.focus();
                      }}
                    >
                      {`چاپ بارکد`}
                    </Button>
                  </Grid>
                )}
              </Grid>
            </Grid>
          )}
        </Grid>
      </form>

      <Dialog
        open={openConfirmDelete}
        fullWidth
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogContent>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
            }}
          >
            {handleClose ? (
              <IconButton
                aria-label="close"
                // className={classes.closeButton}
                onClick={handleClose}
              >
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>
          <div className={classes.cancelIcon}>
            <Icon path={mdiClose} size={4} color={theme.palette.error.main} />
          </div>
          <div
            className={classes.cancelTitle}
          >{`از لغو سفارش با شناسه ${itemDeleted.id} مطمئن هستید؟`}</div>
        </DialogContent>
        <DialogActions className={classes.actionsBox}>
          <Grid container spacing={2}>
            <Grid item xs={8}>
              <Button
                fullWidth
                autoFocus
                onClick={handleClose}
                variant="contained"
                color="secondary"
                size="large"
              >
                {'خیر'}
              </Button>
            </Grid>
            <Grid item xs={4}>
              <Button
                fullWidth
                variant="contained"
                onClick={deleteItemsToParcels}
                size="large"
              >
                {'بله'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>

      <Dialog
        open={checkSubmit}
        fullWidth
        onClose={handleCloseCheckConfirm}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogContent>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
            }}
          >
            {handleClose ? (
              <IconButton aria-label="close" onClick={handleClose}>
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>
          <div className={classes.cancelIcon}>
            <Icon path={mdiCheck} size={4} color={theme.palette.success.main} />
          </div>
          <div className={classes.cancelTitle}>
            {`ایا از ایجاد محموله برای انبار "${
              checkSubmit ? valueWarehouse?.name : ''
            }" مطمئنید؟`}
          </div>
        </DialogContent>
        <DialogActions className={classes.actionsBox}>
          <Grid container spacing={2}>
            <Grid item xs={8}>
              <Button
                fullWidth
                autoFocus
                onClick={handleCloseCheckConfirm}
                variant="contained"
                color="secondary"
                size="large"
              >
                {'خیر'}
              </Button>
            </Grid>
            <Grid item xs={4}>
              <Button
                fullWidth
                variant="contained"
                onClick={handleCreatePostOrder}
                size="large"
              >
                {'بله'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>

      <Modal
        maxWidth="lg"
        onClose={() => setOpenAddItem(false)}
        open={openAddItem}
        title={
          <div className={classes.addIcon}>
            <Icon
              path={mdiPostOutline}
              size={4}
              color={theme.palette.green.main}
            />
          </div>
        }
        content={<Detail id={props.match.params.id} order={props.postOrder} />}
      />

      <Modal
        maxWidth="sm"
        onClose={() => setOpenAddInventoryItem(false)}
        open={openAddInventoryItem}
        title={
          <div className={classes.addIcon}>
            <Icon
              path={mdiArchiveOutline}
              size={4}
              color={theme.palette.green.main}
            />
          </div>
        }
        content={
          <div>mm</div>
          /*<AddInventoryItemsParcelsForm
            product={productObject}
            variant={variantObject}
            count={itemCount}
            addItem={(body: AddInventoryItemCreateParcel[]) =>
              createInventoryItemsToParcels(body)
            }
            onClose={() => setOpenAddInventoryItem(false)}
          />*/
        }
      />
    </>
  );
}

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  order: makeSelectOrder(),
  postOrder: makeSelectPostOrder(),
  currentPostOrder: makeSelectCurrentPostOrder(),
  loading: makeSelectLoading(),
  error: makeSelectError(),
  cities: makeSelectCities(),
  provinces: makeSelectProvinces(),
  citiesLoading: makeSelectCitiesLoading(),
  provincesLoading: makeSelectProvincesLoading(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    orderWithIdActionDispatch: (id: number) =>
      dispatch(getPostOrderWithIdAction({id})),
    provincesActionDispatch: (payload: Payload) =>
      dispatch(getProvincesAction(payload)),
    citiesActionDispatch: (payload: Payload) =>
      dispatch(getCitiesAction(payload)),
    createPostOrderDispatch: (payload: Payload) =>
      dispatch(createPostOrderAction(payload)),
  };
}
const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(Add);
